import request from '@/utils/request'

export function updateTurnCfg(data) {
  return request({
    url: 'api/v1/turn/updateTurnCfg',
    method: 'post',
    data: data
  })
}

export function getTurnCfgList(data) {
  return request({
    url: 'api/v1/turn/getTurnCfg',
    method: 'get',
    params: data
  })
}

export function getTurnPlusCfgList(data) {
  return request({
    url: 'api/v1/turn/getTurnCfgPlus',
    method: 'get',
    params: data
  })
}

export function exportTurnCfg(data) {
  return request({
    url: 'api/v1/turn/export',
    method: 'post',
    data: data
  })
}

export function importTurnCfg(data) {
  return request({
    url: 'api/v1/turn/import',
    method: 'post',
    data: data
  })
}

